// import React, { useState } from "react";
// import { Helmet } from "react-helmet"; // Helmet import

import RandingStyle8 from "../../randing/RandingStyle8";

function Randing006({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle8
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/006/01_20241107_01.jpg`}
      img2Path={`${process.env.REACT_APP_CDN_BASE}/images/006/01_20241107_02.jpg`}
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/006/01_20241107_03.png`}
      companyName="본원"
      animationImg1Path={`${process.env.REACT_APP_CDN_BASE}/images/006/01_20241107_04.png`}
      animationImg2Path={`${process.env.REACT_APP_CDN_BASE}/images/006/01_20241107_04.png`}
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/ggul.jpg`}
    />
  );
}

export default Randing006;
